module.exports = __webpack_public_path__ + "img/icn-card-checked.e6c999cd.png";